import styled from '@emotion/styled';
import { captionM, captionSb } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  background-color: #07736c;
  backdrop-filter: blur(8px);
  padding: 1px 20px;
  width: 100%;
  height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 160px;

  ${DESKTOP} {
    width: 240px;
  }
`;

export const Text = styled.span`
  ${captionSb};
  color: white;

  ${DESKTOP} {
    ${captionM};
    color: white;
  }
`;

export const GrassCountText = styled.span`
  ${captionSb};
  color: ${vars.neutral[30]};

  ${DESKTOP} {
    ${captionSb};
    color: ${vars.neutral[30]};
  }
`;
